import Chat from "./chat";
import Collection from "../../../data-structures/collection";
import {ChatType, EVENT_BUS_SESSION_CHATS_CHANGE} from "./const";
import searchText from "../../../gd/utils/searchText";

export default class ChatsCollection extends Collection<Chat> {

    constructor(models?: Chat[]) {
        super(models);
    }

    sortModels() {

        this.models =
            _.orderBy(
                _.filter(this.models, c => c.companyId === gd.companyId),
                [
                    // @ts-ignore
                    (c: Chat) => this.models.includes(c.id) ? _.indexOf(this.models, c.id) : -1,
                    (c: Chat) => c.newMessages,
                    (c: Chat) => c.momentLastUpdated?.format('X')
                ], ['asc', 'desc', 'desc']
            )
    }

    static initFromJson(data:JSONArray):ChatsCollection {

        const collection = new ChatsCollection()

        const models : Chat[] = []
        _.map(data, (chatData:JSONObject)=>{
            models.push(new Chat(chatData))
        })

        collection.reset(models)

        return collection
    }

    get(id: ID):Chat {
        return this.byId[id] as Chat
    }

    reset(models: Chat[]) {
        super.reset(models)

        gd.bus.triggerEvent(EVENT_BUS_SESSION_CHATS_CHANGE)
    }

    add(model:Chat, sendBusEvent?:boolean) {
        super.add(model)

        if (sendBusEvent) gd.bus.triggerEvent(EVENT_BUS_SESSION_CHATS_CHANGE)
    }

    remove(id: ID): Chat[] {
        const chat = super.remove(id);

        if (chat) gd.bus.triggerEvent(EVENT_BUS_SESSION_CHATS_CHANGE)

        return chat
    }

    search(keyword:string):Chat[] {
        const searchResult = _.filter(this.models, (chat)=>{

            switch (chat.systemType) {
                case ChatType.GROUP:
                case ChatType.PROJECT_DISCUSSION:
                    return searchText(chat.name, keyword)

                case ChatType.USER:
                    if (!chat.talkToUserId) return false
                    return searchText(gd.session.users.get(chat.talkToUserId)!.name, keyword)

            }

        }) as Chat[]
        return searchResult
    }

    get latestUpdatedChat(): Chat {
        const sortedChats: Chat[] = _(this.models)
            .filter(model => model.companyId === gd.companyId)
            .orderBy([
                (c: Chat) => c.momentLastUpdated?.format('X')
            ], ['desc'])
            .value()

        return sortedChats[0]
    }
}